import { gsap } from 'gsap';
const transitionOverlay = document.querySelector('[data-transition-overlay]');

export default {
	name: 'default',
	leave({ current, next, trigger }) {
		return new Promise((resolve) => {

			if(['template-home','template-about', 'template-projects'].includes(next.namespace)) {
				transitionOverlay.classList.add('show-tagline');
			} else {
				transitionOverlay.classList.remove('show-tagline');
			}

			gsap.to(transitionOverlay, {
				autoAlpha: 1,
				ease: 'none',
				duration: 0.3,
				onComplete: () => {
					resolve();
				},
			});
		});
	},

	afterLeave({ current, next, trigger }) {
		return new Promise((resolve) => {
			gsap.set(current.container, {
				position: 'absolute',
				autoAlpha: 0,
			});

			const color_opaque_m = next.container.dataset.colorOpaqueM;
			const color_transparent_m = next.container.dataset.colorTransparentM;
			const background_m = next.container.dataset.backgroundM;

			const color_opaque_d = next.container.dataset.colorOpaqueD;
			const color_transparent_d = next.container.dataset.colorTransparentD;
			const background_d = next.container.dataset.backgroundD;

			gsap.to(document.documentElement, {
				'--color-opaque-m': color_opaque_m,
				'--color-transparent-m': color_transparent_m,
				'--background-m': background_m,
				'--color-opaque-d': color_opaque_d,
				'--color-transparent-d': color_transparent_d,
				'--background-d': background_d,
				duration: 0.3,
				ease: 'none',
				overwrite: true,
				onComplete: () => {
					resolve();
				},
			});
		});
	},

	after({ current, next, trigger }) {
		return new Promise((resolve) => {
			gsap.to(transitionOverlay, {
				autoAlpha: 0,
				ease: 'none',
				duration: 0.3,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
};
